module.exports = __webpack_public_path__ + "img/credit-card.00cb6d5d.svg";